<div edsRow>
  <div edsCol>
    <eds-section-title
      [theme]="titleColorTheme"
      [preTitle]="content?.preTitle"
      [title]="content?.title"
    ></eds-section-title>
  </div>
</div>
